/* eslint-disable */
import {
  FieldPolicy,
  FieldReadFunction,
  TypePolicies,
  TypePolicy,
} from '@apollo/client/cache';
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** Time (isoformat) */
  Time: { input: any; output: any };
  UUID: { input: any; output: any };
};

export type Account = Node & {
  __typename?: 'Account';
  /** The ID of the account */
  id: Scalars['ID']['output'];
  shops: ShopConnection;
};

export type AccountShopsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AddLaneToShopInput = {
  /** The ID of the shop to create the lane in */
  shopId: Scalars['UUID']['input'];
  /** The data for the shop lane */
  shopLaneData: NewShopLaneDataInput;
};

export type AddLaneToShopResponse =
  | InvalidShopLaneInputsError
  | MissingShopError
  | ShopLaneCreated;

export type CreateShopInput = {
  /** The account this shop is in */
  accountId: Scalars['UUID']['input'];
  /** The rooftop this shop is in */
  rooftopId: Scalars['UUID']['input'];
  /** The data for the shop */
  shopData: ShopDataInput;
};

export type CreateShopResponse =
  | InvalidShopInputsError
  | MissingAccountError
  | ShopCreated;

export type DeleteShopInput = {
  /** The ID of the shop to delete */
  shopId: Scalars['UUID']['input'];
};

export type DeleteShopLaneInput = {
  /** The ID of the shop lane to delete */
  shopLaneId: Scalars['UUID']['input'];
};

export type DeleteShopLaneResponse = MissingShopLaneError | ShopLaneDeleted;

export type DeleteShopResponse = MissingShopError | ShopDeleted;

export type InvalidShopInputsError = {
  __typename?: 'InvalidShopInputsError';
  items: Array<Scalars['String']['output']>;
};

export type InvalidShopLaneInputsError = {
  __typename?: 'InvalidShopLaneInputsError';
  items: Array<Scalars['String']['output']>;
};

export type MissingAccountError = {
  __typename?: 'MissingAccountError';
  accountId: Scalars['String']['output'];
};

export type MissingShopError = {
  __typename?: 'MissingShopError';
  shopId: Scalars['String']['output'];
};

export type MissingShopLaneError = {
  __typename?: 'MissingShopLaneError';
  shopLaneId: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addLaneToShop: AddLaneToShopResponse;
  createShop: CreateShopResponse;
  deleteShop: DeleteShopResponse;
  deleteShopLane: DeleteShopLaneResponse;
  setShopLanePosition: SetShopLanePositionResponse;
  updateShop: UpdateShopResponse;
  updateShopLane: UpdateShopLaneResponse;
};

export type MutationAddLaneToShopArgs = {
  input: AddLaneToShopInput;
};

export type MutationCreateShopArgs = {
  input: CreateShopInput;
};

export type MutationDeleteShopArgs = {
  input: DeleteShopInput;
};

export type MutationDeleteShopLaneArgs = {
  input: DeleteShopLaneInput;
};

export type MutationSetShopLanePositionArgs = {
  input: SetShopLanePositionInput;
};

export type MutationUpdateShopArgs = {
  input: UpdateShopInput;
};

export type MutationUpdateShopLaneArgs = {
  input: UpdateShopLaneInput;
};

export type NewShopLaneDataInput = {
  /** How many appointments can be booked in this lane per interval (0 = unlimited) */
  appointmentsPerIntervalLimit: Scalars['Int']['input'];
  /** How many appointments can be booked in this lane in total per day (0 = unlimited) */
  dailyAppointmentLimit: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  /** How this lane is ordered amongst others (lowest number is first, highest number is last) */
  ordinal: Scalars['Int']['input'];
};

/** An object with a Globally Unique ID */
export type Node = {
  /** The Globally Unique ID of this object */
  id: Scalars['ID']['output'];
};

/** Information to aid in pagination. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  account?: Maybe<Account>;
  rooftop?: Maybe<Rooftop>;
  shop?: Maybe<Shop>;
};

export type QueryAccountArgs = {
  id: Scalars['ID']['input'];
};

export type QueryRooftopArgs = {
  id: Scalars['ID']['input'];
};

export type QueryShopArgs = {
  id: Scalars['ID']['input'];
};

export type Rooftop = Node & {
  __typename?: 'Rooftop';
  /** The ID of the rooftop */
  id: Scalars['ID']['output'];
  shops: ShopConnection;
};

export type RooftopShopsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SetShopLanePositionInput = {
  /** The new position of the shop lane */
  position: Scalars['Int']['input'];
  /** The ID of the shop lane to update */
  shopLaneId: Scalars['UUID']['input'];
};

export type SetShopLanePositionResponse =
  | InvalidShopLaneInputsError
  | MissingShopLaneError
  | ShopLanePositionUpdated;

export type Shop = Node & {
  __typename?: 'Shop';
  city: Scalars['String']['output'];
  /** How many appointments can be booked per day */
  dailyAppointmentLimit: Scalars['Int']['output'];
  /** What hours the shop is open */
  hours: Array<ShopHour>;
  /** The ID of the shop */
  id: Scalars['ID']['output'];
  /** How long each appointment slot is in minutes */
  intervalDurationMinutes: Scalars['Int']['output'];
  /** The lanes in the shop */
  lanes: Array<ShopLane>;
  name: Scalars['String']['output'];
  serviceLeadXmlAddress: Scalars['String']['output'];
  state: Scalars['String']['output'];
  /** Whether the shop is active */
  status: ShopStatusGql;
  streetAddress: Scalars['String']['output'];
  /** A tzdata timezone string */
  timezone: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type ShopConnection = {
  __typename?: 'ShopConnection';
  /** Contains the nodes in this connection */
  edges: Array<ShopEdge>;
  /** Pagination data for this connection */
  pageInfo: PageInfo;
};

export type ShopCreated = {
  __typename?: 'ShopCreated';
  shop: Shop;
};

export type ShopDataInput = {
  city: Scalars['String']['input'];
  /** How many appointments can be booked per day */
  dailyAppointmentLimit: Scalars['Int']['input'];
  /** What hours the shop is open */
  hours: Array<ShopHourInput>;
  /** How long each appointment slot is */
  intervalDurationMinutes: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  serviceLeadXmlAddress: Scalars['String']['input'];
  state: Scalars['String']['input'];
  /** Whether the shop is active */
  status: ShopStatusGql;
  streetAddress: Scalars['String']['input'];
  /** A tzdata timezone string */
  timezone: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type ShopDeleted = {
  __typename?: 'ShopDeleted';
  shopId: Scalars['String']['output'];
};

/** An edge in a connection. */
export type ShopEdge = {
  __typename?: 'ShopEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: Shop;
};

export type ShopHour = {
  __typename?: 'ShopHour';
  /** The time the shop closes */
  closeTime: Scalars['Time']['output'];
  /** Integer for the day of the week, 1 = Monday, 7 = Sunday */
  isoDayOfWeek: Scalars['Int']['output'];
  /** The time the shop opens */
  openTime: Scalars['Time']['output'];
};

export type ShopHourInput = {
  /** The time the shop closes */
  closeTime: Scalars['Time']['input'];
  /** Integer for the day of the week, 1 = Monday, 7 = Sunday */
  isoDayOfWeek: Scalars['Int']['input'];
  /** The time the shop opens */
  openTime: Scalars['Time']['input'];
};

export type ShopLane = {
  __typename?: 'ShopLane';
  /** How many appointments can be booked in this lane per interval (0 = unlimited) */
  appointmentsPerIntervalLimit: Scalars['Int']['output'];
  /** How many appointments can be booked in this lane in total per day (0 = unlimited) */
  dailyAppointmentLimit: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** How this lane is ordered amongst others (lowest number is first, highest number is last) */
  ordinal: Scalars['Int']['output'];
};

export type ShopLaneCreated = {
  __typename?: 'ShopLaneCreated';
  shopLane: ShopLane;
};

export type ShopLaneDeleted = {
  __typename?: 'ShopLaneDeleted';
  shopLaneId: Scalars['String']['output'];
};

export type ShopLanePositionUpdated = {
  __typename?: 'ShopLanePositionUpdated';
  shopLane: ShopLane;
};

export type ShopLaneUpdated = {
  __typename?: 'ShopLaneUpdated';
  shopLane: ShopLane;
};

export enum ShopStatusGql {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
}

export type ShopUpdated = {
  __typename?: 'ShopUpdated';
  shop: Shop;
};

export type UpdateShopInput = {
  /** The data for the shop */
  shopData: ShopDataInput;
  /** The ID of the shop to update */
  shopId: Scalars['UUID']['input'];
};

export type UpdateShopLaneDataInput = {
  /** How many appointments can be booked in this lane per interval (0 = unlimited) */
  appointmentsPerIntervalLimit: Scalars['Int']['input'];
  /** How many appointments can be booked in this lane in total per day (0 = unlimited) */
  dailyAppointmentLimit: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type UpdateShopLaneInput = {
  /** The data for the shop lane */
  shopLaneData: UpdateShopLaneDataInput;
  /** The ID of the shop lane to update */
  shopLaneId: Scalars['UUID']['input'];
};

export type UpdateShopLaneResponse =
  | InvalidShopLaneInputsError
  | MissingShopLaneError
  | ShopLaneUpdated;

export type UpdateShopResponse =
  | InvalidShopInputsError
  | MissingShopError
  | ShopUpdated;

export type ShopMetaFragment = {
  __typename?: 'Shop';
  id: string;
  name: string;
  status: ShopStatusGql;
} & { ' $fragmentName'?: 'ShopMetaFragment' };

export type ShopDetailsFragment = {
  __typename?: 'Shop';
  id: string;
  name: string;
  status: ShopStatusGql;
  streetAddress: string;
  city: string;
  state: string;
  zipCode: string;
  serviceLeadXmlAddress: string;
  timezone: string;
  intervalDurationMinutes: number;
  dailyAppointmentLimit: number;
  hours: Array<{
    __typename?: 'ShopHour';
    isoDayOfWeek: number;
    openTime: any;
    closeTime: any;
  }>;
} & { ' $fragmentName'?: 'ShopDetailsFragment' };

export type ShopLaneDetailsFragment = {
  __typename?: 'ShopLane';
  id: string;
  name: string;
  ordinal: number;
  dailyAppointmentLimit: number;
  appointmentsPerIntervalLimit: number;
} & { ' $fragmentName'?: 'ShopLaneDetailsFragment' };

export type ShopsInAccountQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;

export type ShopsInAccountQuery = {
  __typename?: 'Query';
  account?: {
    __typename?: 'Account';
    id: string;
    shops: {
      __typename?: 'ShopConnection';
      edges: Array<{
        __typename?: 'ShopEdge';
        node: { __typename?: 'Shop' } & {
          ' $fragmentRefs'?: { ShopMetaFragment: ShopMetaFragment };
        };
      }>;
    };
  } | null;
};

export type ShopsInRooftopQueryVariables = Exact<{
  rooftopId: Scalars['ID']['input'];
}>;

export type ShopsInRooftopQuery = {
  __typename?: 'Query';
  rooftop?: {
    __typename?: 'Rooftop';
    id: string;
    shops: {
      __typename?: 'ShopConnection';
      edges: Array<{
        __typename?: 'ShopEdge';
        node: { __typename?: 'Shop' } & {
          ' $fragmentRefs'?: { ShopMetaFragment: ShopMetaFragment };
        };
      }>;
    };
  } | null;
};

export type GetShopQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetShopQuery = {
  __typename?: 'Query';
  shop?:
    | ({ __typename?: 'Shop' } & {
        ' $fragmentRefs'?: { ShopDetailsFragment: ShopDetailsFragment };
      })
    | null;
};

export type GetShopLanesQueryVariables = Exact<{
  shopId: Scalars['ID']['input'];
}>;

export type GetShopLanesQuery = {
  __typename?: 'Query';
  shop?: {
    __typename?: 'Shop';
    lanes: Array<
      { __typename?: 'ShopLane' } & {
        ' $fragmentRefs'?: { ShopLaneDetailsFragment: ShopLaneDetailsFragment };
      }
    >;
  } | null;
};

export type CreateShopInAccountMutationVariables = Exact<{
  input: CreateShopInput;
}>;

export type CreateShopInAccountMutation = {
  __typename?: 'Mutation';
  createShop:
    | { __typename: 'InvalidShopInputsError'; items: Array<string> }
    | { __typename: 'MissingAccountError'; accountId: string }
    | {
        __typename: 'ShopCreated';
        shop: { __typename?: 'Shop' } & {
          ' $fragmentRefs'?: { ShopDetailsFragment: ShopDetailsFragment };
        };
      };
};

export type UpdateShopMutationVariables = Exact<{
  input: UpdateShopInput;
}>;

export type UpdateShopMutation = {
  __typename?: 'Mutation';
  updateShop:
    | { __typename: 'InvalidShopInputsError'; items: Array<string> }
    | { __typename: 'MissingShopError'; shopId: string }
    | {
        __typename: 'ShopUpdated';
        shop: { __typename?: 'Shop' } & {
          ' $fragmentRefs'?: { ShopDetailsFragment: ShopDetailsFragment };
        };
      };
};

export type DeleteShopMutationVariables = Exact<{
  input: DeleteShopInput;
}>;

export type DeleteShopMutation = {
  __typename?: 'Mutation';
  deleteShop:
    | { __typename: 'MissingShopError'; shopId: string }
    | { __typename: 'ShopDeleted'; shopId: string };
};

export type AddLaneToShopMutationVariables = Exact<{
  input: AddLaneToShopInput;
}>;

export type AddLaneToShopMutation = {
  __typename?: 'Mutation';
  addLaneToShop:
    | { __typename: 'InvalidShopLaneInputsError'; items: Array<string> }
    | { __typename: 'MissingShopError'; shopId: string }
    | {
        __typename: 'ShopLaneCreated';
        shopLane: {
          __typename?: 'ShopLane';
          id: string;
          name: string;
          ordinal: number;
          dailyAppointmentLimit: number;
          appointmentsPerIntervalLimit: number;
        };
      };
};

export type SetShopLanePositionMutationVariables = Exact<{
  input: SetShopLanePositionInput;
}>;

export type SetShopLanePositionMutation = {
  __typename?: 'Mutation';
  setShopLanePosition:
    | { __typename: 'InvalidShopLaneInputsError'; items: Array<string> }
    | { __typename: 'MissingShopLaneError'; shopLaneId: string }
    | {
        __typename: 'ShopLanePositionUpdated';
        shopLane: {
          __typename?: 'ShopLane';
          id: string;
          name: string;
          ordinal: number;
          dailyAppointmentLimit: number;
          appointmentsPerIntervalLimit: number;
        };
      };
};

export type UpdateShopLaneMutationVariables = Exact<{
  input: UpdateShopLaneInput;
}>;

export type UpdateShopLaneMutation = {
  __typename?: 'Mutation';
  updateShopLane:
    | { __typename: 'InvalidShopLaneInputsError'; items: Array<string> }
    | { __typename: 'MissingShopLaneError'; shopLaneId: string }
    | {
        __typename: 'ShopLaneUpdated';
        shopLane: {
          __typename?: 'ShopLane';
          id: string;
          name: string;
          ordinal: number;
          dailyAppointmentLimit: number;
          appointmentsPerIntervalLimit: number;
        };
      };
};

export type DeleteShopLaneMutationVariables = Exact<{
  input: DeleteShopLaneInput;
}>;

export type DeleteShopLaneMutation = {
  __typename?: 'Mutation';
  deleteShopLane:
    | { __typename: 'MissingShopLaneError'; shopLaneId: string }
    | { __typename: 'ShopLaneDeleted'; shopLaneId: string };
};

export const ShopMetaFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopMeta' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Shop' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShopMetaFragment, unknown>;
export const ShopDetailsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Shop' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceLeadXmlAddress' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'intervalDurationMinutes' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dailyAppointmentLimit' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hours' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isoDayOfWeek' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'openTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closeTime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShopDetailsFragment, unknown>;
export const ShopLaneDetailsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopLaneDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ShopLane' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ordinal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dailyAppointmentLimit' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentsPerIntervalLimit' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShopLaneDetailsFragment, unknown>;
export const ShopsInAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'shopsInAccount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shops' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'ShopMeta' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopMeta' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Shop' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShopsInAccountQuery, ShopsInAccountQueryVariables>;
export const ShopsInRooftopDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'shopsInRooftop' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'rooftopId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rooftop' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'rooftopId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shops' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'ShopMeta' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopMeta' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Shop' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShopsInRooftopQuery, ShopsInRooftopQueryVariables>;
export const GetShopDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getShop' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shop' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ShopDetails' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Shop' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceLeadXmlAddress' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'intervalDurationMinutes' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dailyAppointmentLimit' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hours' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isoDayOfWeek' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'openTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closeTime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetShopQuery, GetShopQueryVariables>;
export const GetShopLanesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getShopLanes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'shopId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shop' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'shopId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lanes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ShopLaneDetails' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopLaneDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ShopLane' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ordinal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dailyAppointmentLimit' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appointmentsPerIntervalLimit' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetShopLanesQuery, GetShopLanesQueryVariables>;
export const CreateShopInAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createShopInAccount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateShopInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createShop' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ShopCreated' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shop' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'ShopDetails' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'InvalidShopInputsError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'items' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MissingAccountError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Shop' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceLeadXmlAddress' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'intervalDurationMinutes' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dailyAppointmentLimit' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hours' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isoDayOfWeek' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'openTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closeTime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateShopInAccountMutation,
  CreateShopInAccountMutationVariables
>;
export const UpdateShopDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateShop' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateShopInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateShop' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ShopUpdated' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shop' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'ShopDetails' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'InvalidShopInputsError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'items' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MissingShopError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ShopDetails' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Shop' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'streetAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceLeadXmlAddress' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'intervalDurationMinutes' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dailyAppointmentLimit' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hours' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isoDayOfWeek' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'openTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'closeTime' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateShopMutation, UpdateShopMutationVariables>;
export const DeleteShopDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteShop' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteShopInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteShop' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ShopDeleted' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MissingShopError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteShopMutation, DeleteShopMutationVariables>;
export const AddLaneToShopDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'addLaneToShop' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AddLaneToShopInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addLaneToShop' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ShopLaneCreated' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopLane' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ordinal' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'dailyAppointmentLimit',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'appointmentsPerIntervalLimit',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'InvalidShopLaneInputsError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'items' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MissingShopError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddLaneToShopMutation,
  AddLaneToShopMutationVariables
>;
export const SetShopLanePositionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setShopLanePosition' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SetShopLanePositionInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setShopLanePosition' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ShopLanePositionUpdated' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopLane' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ordinal' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'dailyAppointmentLimit',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'appointmentsPerIntervalLimit',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'InvalidShopLaneInputsError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'items' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MissingShopLaneError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopLaneId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetShopLanePositionMutation,
  SetShopLanePositionMutationVariables
>;
export const UpdateShopLaneDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateShopLane' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateShopLaneInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateShopLane' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ShopLaneUpdated' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopLane' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ordinal' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'dailyAppointmentLimit',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'appointmentsPerIntervalLimit',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'InvalidShopLaneInputsError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'items' } },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MissingShopLaneError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopLaneId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateShopLaneMutation,
  UpdateShopLaneMutationVariables
>;
export const DeleteShopLaneDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteShopLane' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteShopLaneInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteShopLane' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ShopLaneDeleted' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopLaneId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MissingShopLaneError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shopLaneId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteShopLaneMutation,
  DeleteShopLaneMutationVariables
>;

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    AddLaneToShopResponse: [
      'InvalidShopLaneInputsError',
      'MissingShopError',
      'ShopLaneCreated',
    ],
    CreateShopResponse: [
      'InvalidShopInputsError',
      'MissingAccountError',
      'ShopCreated',
    ],
    DeleteShopLaneResponse: ['MissingShopLaneError', 'ShopLaneDeleted'],
    DeleteShopResponse: ['MissingShopError', 'ShopDeleted'],
    Node: ['Account', 'Rooftop', 'Shop'],
    SetShopLanePositionResponse: [
      'InvalidShopLaneInputsError',
      'MissingShopLaneError',
      'ShopLanePositionUpdated',
    ],
    UpdateShopLaneResponse: [
      'InvalidShopLaneInputsError',
      'MissingShopLaneError',
      'ShopLaneUpdated',
    ],
    UpdateShopResponse: [
      'InvalidShopInputsError',
      'MissingShopError',
      'ShopUpdated',
    ],
  },
};
export default result;

export type AccountKeySpecifier = ('id' | 'shops' | AccountKeySpecifier)[];
export type AccountFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  shops?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InvalidShopInputsErrorKeySpecifier = (
  | 'items'
  | InvalidShopInputsErrorKeySpecifier
)[];
export type InvalidShopInputsErrorFieldPolicy = {
  items?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type InvalidShopLaneInputsErrorKeySpecifier = (
  | 'items'
  | InvalidShopLaneInputsErrorKeySpecifier
)[];
export type InvalidShopLaneInputsErrorFieldPolicy = {
  items?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MissingAccountErrorKeySpecifier = (
  | 'accountId'
  | MissingAccountErrorKeySpecifier
)[];
export type MissingAccountErrorFieldPolicy = {
  accountId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MissingShopErrorKeySpecifier = (
  | 'shopId'
  | MissingShopErrorKeySpecifier
)[];
export type MissingShopErrorFieldPolicy = {
  shopId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MissingShopLaneErrorKeySpecifier = (
  | 'shopLaneId'
  | MissingShopLaneErrorKeySpecifier
)[];
export type MissingShopLaneErrorFieldPolicy = {
  shopLaneId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type MutationKeySpecifier = (
  | 'addLaneToShop'
  | 'createShop'
  | 'deleteShop'
  | 'deleteShopLane'
  | 'setShopLanePosition'
  | 'updateShop'
  | 'updateShopLane'
  | MutationKeySpecifier
)[];
export type MutationFieldPolicy = {
  addLaneToShop?: FieldPolicy<any> | FieldReadFunction<any>;
  createShop?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteShop?: FieldPolicy<any> | FieldReadFunction<any>;
  deleteShopLane?: FieldPolicy<any> | FieldReadFunction<any>;
  setShopLanePosition?: FieldPolicy<any> | FieldReadFunction<any>;
  updateShop?: FieldPolicy<any> | FieldReadFunction<any>;
  updateShopLane?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type NodeKeySpecifier = ('id' | NodeKeySpecifier)[];
export type NodeFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type PageInfoKeySpecifier = (
  | 'endCursor'
  | 'hasNextPage'
  | 'hasPreviousPage'
  | 'startCursor'
  | PageInfoKeySpecifier
)[];
export type PageInfoFieldPolicy = {
  endCursor?: FieldPolicy<any> | FieldReadFunction<any>;
  hasNextPage?: FieldPolicy<any> | FieldReadFunction<any>;
  hasPreviousPage?: FieldPolicy<any> | FieldReadFunction<any>;
  startCursor?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type QueryKeySpecifier = (
  | 'account'
  | 'rooftop'
  | 'shop'
  | QueryKeySpecifier
)[];
export type QueryFieldPolicy = {
  account?: FieldPolicy<any> | FieldReadFunction<any>;
  rooftop?: FieldPolicy<any> | FieldReadFunction<any>;
  shop?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type RooftopKeySpecifier = ('id' | 'shops' | RooftopKeySpecifier)[];
export type RooftopFieldPolicy = {
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  shops?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopKeySpecifier = (
  | 'city'
  | 'dailyAppointmentLimit'
  | 'hours'
  | 'id'
  | 'intervalDurationMinutes'
  | 'lanes'
  | 'name'
  | 'serviceLeadXmlAddress'
  | 'state'
  | 'status'
  | 'streetAddress'
  | 'timezone'
  | 'zipCode'
  | ShopKeySpecifier
)[];
export type ShopFieldPolicy = {
  city?: FieldPolicy<any> | FieldReadFunction<any>;
  dailyAppointmentLimit?: FieldPolicy<any> | FieldReadFunction<any>;
  hours?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  intervalDurationMinutes?: FieldPolicy<any> | FieldReadFunction<any>;
  lanes?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  serviceLeadXmlAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  state?: FieldPolicy<any> | FieldReadFunction<any>;
  status?: FieldPolicy<any> | FieldReadFunction<any>;
  streetAddress?: FieldPolicy<any> | FieldReadFunction<any>;
  timezone?: FieldPolicy<any> | FieldReadFunction<any>;
  zipCode?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopConnectionKeySpecifier = (
  | 'edges'
  | 'pageInfo'
  | ShopConnectionKeySpecifier
)[];
export type ShopConnectionFieldPolicy = {
  edges?: FieldPolicy<any> | FieldReadFunction<any>;
  pageInfo?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopCreatedKeySpecifier = ('shop' | ShopCreatedKeySpecifier)[];
export type ShopCreatedFieldPolicy = {
  shop?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopDeletedKeySpecifier = ('shopId' | ShopDeletedKeySpecifier)[];
export type ShopDeletedFieldPolicy = {
  shopId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopEdgeKeySpecifier = ('cursor' | 'node' | ShopEdgeKeySpecifier)[];
export type ShopEdgeFieldPolicy = {
  cursor?: FieldPolicy<any> | FieldReadFunction<any>;
  node?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopHourKeySpecifier = (
  | 'closeTime'
  | 'isoDayOfWeek'
  | 'openTime'
  | ShopHourKeySpecifier
)[];
export type ShopHourFieldPolicy = {
  closeTime?: FieldPolicy<any> | FieldReadFunction<any>;
  isoDayOfWeek?: FieldPolicy<any> | FieldReadFunction<any>;
  openTime?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopLaneKeySpecifier = (
  | 'appointmentsPerIntervalLimit'
  | 'dailyAppointmentLimit'
  | 'id'
  | 'name'
  | 'ordinal'
  | ShopLaneKeySpecifier
)[];
export type ShopLaneFieldPolicy = {
  appointmentsPerIntervalLimit?: FieldPolicy<any> | FieldReadFunction<any>;
  dailyAppointmentLimit?: FieldPolicy<any> | FieldReadFunction<any>;
  id?: FieldPolicy<any> | FieldReadFunction<any>;
  name?: FieldPolicy<any> | FieldReadFunction<any>;
  ordinal?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopLaneCreatedKeySpecifier = (
  | 'shopLane'
  | ShopLaneCreatedKeySpecifier
)[];
export type ShopLaneCreatedFieldPolicy = {
  shopLane?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopLaneDeletedKeySpecifier = (
  | 'shopLaneId'
  | ShopLaneDeletedKeySpecifier
)[];
export type ShopLaneDeletedFieldPolicy = {
  shopLaneId?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopLanePositionUpdatedKeySpecifier = (
  | 'shopLane'
  | ShopLanePositionUpdatedKeySpecifier
)[];
export type ShopLanePositionUpdatedFieldPolicy = {
  shopLane?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopLaneUpdatedKeySpecifier = (
  | 'shopLane'
  | ShopLaneUpdatedKeySpecifier
)[];
export type ShopLaneUpdatedFieldPolicy = {
  shopLane?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type ShopUpdatedKeySpecifier = ('shop' | ShopUpdatedKeySpecifier)[];
export type ShopUpdatedFieldPolicy = {
  shop?: FieldPolicy<any> | FieldReadFunction<any>;
};
export type StrictTypedTypePolicies = {
  Account?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | AccountKeySpecifier
      | (() => undefined | AccountKeySpecifier);
    fields?: AccountFieldPolicy;
  };
  InvalidShopInputsError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InvalidShopInputsErrorKeySpecifier
      | (() => undefined | InvalidShopInputsErrorKeySpecifier);
    fields?: InvalidShopInputsErrorFieldPolicy;
  };
  InvalidShopLaneInputsError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | InvalidShopLaneInputsErrorKeySpecifier
      | (() => undefined | InvalidShopLaneInputsErrorKeySpecifier);
    fields?: InvalidShopLaneInputsErrorFieldPolicy;
  };
  MissingAccountError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MissingAccountErrorKeySpecifier
      | (() => undefined | MissingAccountErrorKeySpecifier);
    fields?: MissingAccountErrorFieldPolicy;
  };
  MissingShopError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MissingShopErrorKeySpecifier
      | (() => undefined | MissingShopErrorKeySpecifier);
    fields?: MissingShopErrorFieldPolicy;
  };
  MissingShopLaneError?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MissingShopLaneErrorKeySpecifier
      | (() => undefined | MissingShopLaneErrorKeySpecifier);
    fields?: MissingShopLaneErrorFieldPolicy;
  };
  Mutation?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | MutationKeySpecifier
      | (() => undefined | MutationKeySpecifier);
    fields?: MutationFieldPolicy;
  };
  Node?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | NodeKeySpecifier | (() => undefined | NodeKeySpecifier);
    fields?: NodeFieldPolicy;
  };
  PageInfo?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | PageInfoKeySpecifier
      | (() => undefined | PageInfoKeySpecifier);
    fields?: PageInfoFieldPolicy;
  };
  Query?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | QueryKeySpecifier
      | (() => undefined | QueryKeySpecifier);
    fields?: QueryFieldPolicy;
  };
  Rooftop?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | RooftopKeySpecifier
      | (() => undefined | RooftopKeySpecifier);
    fields?: RooftopFieldPolicy;
  };
  Shop?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?: false | ShopKeySpecifier | (() => undefined | ShopKeySpecifier);
    fields?: ShopFieldPolicy;
  };
  ShopConnection?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopConnectionKeySpecifier
      | (() => undefined | ShopConnectionKeySpecifier);
    fields?: ShopConnectionFieldPolicy;
  };
  ShopCreated?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopCreatedKeySpecifier
      | (() => undefined | ShopCreatedKeySpecifier);
    fields?: ShopCreatedFieldPolicy;
  };
  ShopDeleted?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopDeletedKeySpecifier
      | (() => undefined | ShopDeletedKeySpecifier);
    fields?: ShopDeletedFieldPolicy;
  };
  ShopEdge?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopEdgeKeySpecifier
      | (() => undefined | ShopEdgeKeySpecifier);
    fields?: ShopEdgeFieldPolicy;
  };
  ShopHour?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopHourKeySpecifier
      | (() => undefined | ShopHourKeySpecifier);
    fields?: ShopHourFieldPolicy;
  };
  ShopLane?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopLaneKeySpecifier
      | (() => undefined | ShopLaneKeySpecifier);
    fields?: ShopLaneFieldPolicy;
  };
  ShopLaneCreated?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopLaneCreatedKeySpecifier
      | (() => undefined | ShopLaneCreatedKeySpecifier);
    fields?: ShopLaneCreatedFieldPolicy;
  };
  ShopLaneDeleted?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopLaneDeletedKeySpecifier
      | (() => undefined | ShopLaneDeletedKeySpecifier);
    fields?: ShopLaneDeletedFieldPolicy;
  };
  ShopLanePositionUpdated?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopLanePositionUpdatedKeySpecifier
      | (() => undefined | ShopLanePositionUpdatedKeySpecifier);
    fields?: ShopLanePositionUpdatedFieldPolicy;
  };
  ShopLaneUpdated?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopLaneUpdatedKeySpecifier
      | (() => undefined | ShopLaneUpdatedKeySpecifier);
    fields?: ShopLaneUpdatedFieldPolicy;
  };
  ShopUpdated?: Omit<TypePolicy, 'fields' | 'keyFields'> & {
    keyFields?:
      | false
      | ShopUpdatedKeySpecifier
      | (() => undefined | ShopUpdatedKeySpecifier);
    fields?: ShopUpdatedFieldPolicy;
  };
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;
/* This is an auto-generated file by generateApolloMergeableTypes.js */

export const mergeableTypesArray = [
  'Account',
  'InvalidShopInputsError',
  'InvalidShopLaneInputsError',
  'MissingAccountError',
  'MissingShopError',
  'MissingShopLaneError',
  'Mutation',
  'Node',
  'PageInfo',
  'Query',
  'Rooftop',
  'Shop',
  'ShopConnection',
  'ShopCreated',
  'ShopDeleted',
  'ShopEdge',
  'ShopHour',
  'ShopLane',
  'ShopLaneCreated',
  'ShopLaneDeleted',
  'ShopLanePositionUpdated',
  'ShopLaneUpdated',
  'ShopUpdated',
];
